import {createSlice} from '@reduxjs/toolkit';
import {
    getEmployeeGroupsData,
    getEmployeeParkingEvents,
    deleteEmployeeGroupData,
} from './employee-parking-actions';
import {
    employeeParkingEventsAdapter,
    employeeParkingGroupsAdapter,
} from './employee-parking-adapters';

export interface EmployeeParkingState {
    groups: {
        data: ReturnType<typeof employeeParkingGroupsAdapter.getInitialState>;
        meta: {
            count: number;
            limit: number;
            offset: number;
            nextOffset: number;
        };
        loading: boolean;
    };
    events: {
        data: ReturnType<typeof employeeParkingEventsAdapter.getInitialState>;
        meta: {
            count: number;
            page: number;
            pageSize: number;
        };
        loading: boolean;
    };
}

const initialState: EmployeeParkingState = {
    groups: {
        data: employeeParkingGroupsAdapter.getInitialState(),
        meta: {
            count: 0,
            limit: 25,
            offset: 0,
            nextOffset: 25,
        },
        loading: false,
    },
    events: {
        data: employeeParkingEventsAdapter.getInitialState(),
        meta: {
            count: 0,
            page: 1,
            pageSize: 10,
        },
        loading: false,
    },
};

const employeeParking = createSlice({
    name: 'employeeParking',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getEmployeeGroupsData.pending, (state) => {
                state.groups.loading = true;
            })
            .addCase(getEmployeeGroupsData.fulfilled, (state, {payload}) => {
                employeeParkingGroupsAdapter.setAll(
                    state.groups.data,
                    payload.data.results
                );
                state.groups.meta = payload.meta;
                state.groups.loading = false;
            })
            .addCase(deleteEmployeeGroupData.fulfilled, (state, {payload}) => {
                employeeParkingGroupsAdapter.removeOne(
                    state.groups.data,
                    payload
                );
            })
            .addCase(getEmployeeParkingEvents.pending, (state) => {
                state.events.loading = true;
            })
            .addCase(getEmployeeParkingEvents.fulfilled, (state, {payload}) => {
                employeeParkingEventsAdapter.setAll(
                    state.events.data,
                    payload.events
                );
                state.events.meta = {
                    ...state.events.meta,
                    ...payload.meta,
                };
                state.events.loading = false;
            })
            .addCase(getEmployeeParkingEvents.rejected, (state) => {
                state.events.loading = false;
            });
    },
});

export default employeeParking.reducer;
